import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
  List,
  ListItem,
  Divider
} from '@mui/material';
import { format } from 'date-fns';
import api from '../../../services/api';
import { toast } from 'react-toastify';
import { formatCurrency } from '../../../utils/formatters';

export default function HistoricoEdicoes({ open, onClose, emprestimoId, onSuccess }) {
  const [edicoes, setEdicoes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadEdicoes = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/emprestimos/${emprestimoId}/edicoes`);
        setEdicoes(response.data);
      } catch (error) {
        toast.error('Erro ao carregar histórico de edições');
      } finally {
        setLoading(false);
      }
    };

    if (open && emprestimoId) {
      loadEdicoes();
    }
  }, [open, emprestimoId]);

  const handleReverter = async (id_edicao) => {
    if (!window.confirm('Tem certeza que deseja desfazer esta edição e voltar o contrato para este estado?')) {
      return;
    }
    try {
      await api.post(`/emprestimos/${emprestimoId}/reverter`, { id_edicao });
      toast.success('Edição revertida com sucesso!');
      onSuccess();
      onClose();
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erro ao reverter edição');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Histórico de Edições</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : edicoes.length === 0 ? (
          <Typography color="textSecondary" align="center" sx={{ mt: 2 }}>
            Nenhuma edição registrada para este empréstimo.
          </Typography>
        ) : (
          <List>
            {edicoes.map((edicao, index) => {
              const dadosAntigos = edicao.dados_emprestimo_antigo;
              return (
                <React.Fragment key={edicao.id}>
                  <ListItem sx={{ flexDirection: 'column', alignItems: 'flex-start', py: 2 }}>
                    <Box display="flex" justifyContent="space-between" width="100%" mb={1}>
                      <Typography variant="subtitle2" fontWeight="bold">
                        Edição em {format(new Date(edicao.data_edicao), 'dd/MM/yyyy HH:mm')}
                      </Typography>
                      {index === 0 && (
                        <Button 
                          size="small" 
                          variant="outlined" 
                          color="error"
                          onClick={() => handleReverter(edicao.id)}
                        >
                          Desfazer Esta Edição
                        </Button>
                      )}
                    </Box>
                    <Box sx={{ width: '100%', bgcolor: '#f5f5f5', p: 1.5, borderRadius: 1 }}>
                      <Typography variant="body2">
                        <b>Motivo:</b> {edicao.motivo_edicao || 'Não informado'}
                      </Typography>
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        <b>Como era ANTES da edição:</b><br />
                        Valor Total Original: {formatCurrency(dadosAntigos.valor_principal_original || dadosAntigos.valor_total)}<br />
                        Taxa de Juros: {dadosAntigos.taxa_juros}%<br />
                        Parcelas: {dadosAntigos.quantidade_parcelas_original || dadosAntigos.quantidade_parcelas} ({dadosAntigos.periodicidade})
                      </Typography>
                    </Box>
                  </ListItem>
                  {index < edicoes.length - 1 && <Divider />}
                </React.Fragment>
              );
            })}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}
